const useArticle = function (articleConfig) {
  const { main = {}, side = {} } = articleConfig
  /** 是否为简约列表；列表大小；列表样式 是否需要背景框；是否显示分割线 */
  const { isSimpleList, styleSize, type, showSplit } = main

  /** 图片位置 */
  const imagePosition = main.image && main.image.position
  /** 图片是否和文字显示一行 */
  const imageIsLine = imagePosition === 'left' || imagePosition === 'right'
  /** 用来判断是否显示文章tag，以及存放的slug */
  const tagSlug = main.tag && main.tag.slug
  /** 用来判断是否显示文章标题，以及存放的slug */
  const titleSlug = main.title && main.title.slug
  /** 用来判断是否显示文章内容，以及存放的slug */
  const summarySlug = main.summary && main.summary.slug
  /** 用来判断是否显示avatar，以及存放的slug */
  // const avatarSlug = false
  /** 用来判断是否显示作者名称，以及存放的slug */
  const createBySlug = main.createdBy && main.createdBy.slug
  /** 用来判断是否显示时间，以及存放的slug */
  const dateSlug = main.date && main.date.slug
  /** 用来判断是否显示image，以及存放的slug */
  const imageSlug = main.image && main.image.slug
  /** 用来判断是否显示区分账号icon，以及存放的slug */
  const accountTypeSlug = main.accountType && main.accountType.slug
  /** 主列表-底部在一行显示的内容（点赞、评论..） */
  const bottomField_main = main.fields

  /** 其他文章-底部在一行显示的内容（点赞、评论..） */
  const bottomField_side = side.fields
  /** 其他文章-用来判断是否显示文章标题，以及存放的slug */
  const titleSlug_side = side.title && side.title.slug
  /** 其他文章-用来判断是否显示作者名称，以及存放的slug */
  const createBySlug_side = side.createdBy && side.createdBy.slug
  /** 其他文章-用来排序的slug */
  const sortSlug_side = side.sortSlug
  /** 用来判断是否显示区分账号icon，以及存放的slug */
  const accountTypeSlug_side = side.accountType && side.accountType.slug
  /** 是否显示其他文章 */
  const isShowSide = side.show

  /** tag标签颜色 */
  const tagColors = [
    '#C63232',
    '#06A870',
    '#9963D8',
    '#D96E47',
    '#008FF7',
    '#D42D9D',
    '#2BBCC5',
    '#E19707',
    '#6D50DD',
    '#A1B221',
  ]

  /**
   * 将数字转换为千位分隔符
   * @param {*} num
   * @returns
   */
  const toThousands = (num) => {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  }

  return {
    isSimpleList,
    imagePosition,
    imageIsLine,
    tagSlug,
    titleSlug,
    summarySlug,
    createBySlug,
    dateSlug,
    imageSlug,
    accountTypeSlug,
    bottomField_main,
    bottomField_side,
    titleSlug_side,
    createBySlug_side,
    sortSlug_side,
    accountTypeSlug_side,
    isShowSide,
    articleConfig,
    tagColors,
    type,
    styleSize,
    showSplit,
    toThousands,
  }
}
export default useArticle
